var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
import { Service } from "~/core/service";
var PersonalService = /** @class */ (function (_super) {
    __extends(PersonalService, _super);
    function PersonalService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 创建联系人地址
     * @param data 实体对象
     */
    PersonalService.prototype.inertPersonalAddress = function (data, loading) {
        return this.netService.send({
            server: domainService.personalController.inertPersonalAddress,
            data: data,
            loading: loading
        });
    };
    /**
     * 修改联系人地址
     * @param data
     * @param loading 加载等待
     */
    PersonalService.prototype.modifyPersonalAddress = function (data, loading) {
        return this.netService.send({
            server: domainService.personalController.modifyPersonalAddress,
            data: data,
            loading: loading
        });
    };
    /**
     * 删除联系人地址
     * @param data
     * @param loading
     */
    PersonalService.prototype.deleteAddressContact = function (data, loading) {
        return this.netService.send({
            server: domainService.personalController.deleteAddressContact,
            data: data,
            loading: loading
        });
    };
    /**
     * 创建联系人
     * @param data 实体对象
     */
    PersonalService.prototype.inertPersonalContact = function (data, loading) {
        return this.netService.send({
            server: domainService.personalController.inertPersonalContact,
            data: data,
            loading: loading
        });
    };
    /**
     * 修改联系人
     * @param data 实体对象
     */
    PersonalService.prototype.modifyPersonalContact = function (data, loading) {
        return this.netService.send({
            server: domainService.personalController.modifyPersonalContact,
            data: data,
            loading: loading
        });
    };
    /**
     * 联系人地址查询
     */
    PersonalService.prototype.searchPersonalAddress = function (personalId, loading) {
        return this.netService.send({
            server: domainService.personalController.searchPersonalAddress,
            data: {
                personalId: personalId
            },
            loading: loading
        });
    };
    /**
     * 联系人电话查询
     */
    PersonalService.prototype.searchPersonalContact = function (personalId, loading) {
        return this.netService.send({
            server: domainService.personalController.searchPersonalContact,
            data: {
                personalId: personalId
            },
            loading: loading
        });
    };
    /**
     * 删除联系人
     * @param data
     * @param loading
     */
    PersonalService.prototype.deletePersonalContact = function (data, loading) {
        return this.netService.send({
            server: domainService.personalController.deletePersonalContact,
            data: data,
            loading: loading
        });
    };
    /**
     * 更新联系人电话或地址状态
     * @param data
     * @param loading 加载等待
     */
    PersonalService.prototype.markPhoneOrAddressStatus = function (data, loading) {
        return this.netService.send({
            server: domainService.personalController.markPhoneOrAddressStatus,
            data: data,
            loading: loading
        });
    };
    /**
     * 修改联系人禁用状态
     * @param data 实体对象
     */
    PersonalService.prototype.modifyBanState = function (data, loading) {
        return this.netService.send({
            server: domainService.personalController.modifyBanState,
            data: data,
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], PersonalService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], PersonalService.prototype, "inertPersonalAddress", null);
    __decorate([
        Debounce()
    ], PersonalService.prototype, "inertPersonalContact", null);
    __decorate([
        Debounce()
    ], PersonalService.prototype, "modifyPersonalContact", null);
    __decorate([
        Debounce()
    ], PersonalService.prototype, "modifyBanState", null);
    return PersonalService;
}(Service));
export { PersonalService };
